import { ChangeDetectionStrategy, Component, inject } from '@angular/core';
import { SvgIconComponent } from '@ngneat/svg-icon';
import { TranslatePipe } from '@ngx-translate/core';
import { EXTERNAL_LINKS } from '@libs/utils';
import { BaaRequestFlowService } from '../baa-request-flow.service';
import { BaaRequestListItemsComponent } from '../baa-request-list-items/baa-request-list-items.component';

@Component({
  selector: 'lib-baa-request-list',
  imports: [SvgIconComponent, TranslatePipe, BaaRequestListItemsComponent],
  templateUrl: './baa-request-list.component.html',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class BaaRequestListComponent {
  protected readonly service = inject(BaaRequestFlowService);
  protected readonly iosAppUrl = EXTERNAL_LINKS.FFD_NOTES_IOS_APP;

  protected readonly practiceName = this.service.practiceNameSignal;
  protected readonly notifiedRequesterName = this.service.notifiedRequesterNameSignal;
}
